module.exports = __webpack_public_path__ + "img/dataIcon.c49cad06.png";